import React, { useState, useCallback } from 'react';
import { Row, Column, Paragraph, PrivacyPolicy } from './Terms.styles';
import { useWindowSize } from './hooks';
import { CardBody, CardFooter, CardHeader, Button } from 'view/components/common';
import { FormCheckbox } from 'view/components/common/inputs';
import { Spinner } from 'view/components/layout';

interface TermsProps {
    stepNavigator : (increment: boolean) => () => void;
}

export const Terms: React.FunctionComponent<TermsProps> = ({ stepNavigator }) => 
{
    const [ loading, setLoading ] = useState(false);
    const [ hasAgreed, setHasAgreed ] = useState(false);
    const size = useWindowSize();
    const isLargeScreen = size.width >= 1900;

    const openURL = useCallback(url => 
    {
        return () => 
        {
            window.open(url, '_blank');
        };
    }, []);

    const onSubmit = useCallback(() => 
    {
        setLoading(true);
        setTimeout(() => 
        {
            stepNavigator(true)();
        }, 500);
    }, [ stepNavigator, setLoading ]);

    return (
        <>
            <CardHeader
                content={'Credit Pull'}
                step={'Step 1'}
                backHandler={stepNavigator(false)}
            />
            {loading ? (
                <Spinner css='height: inherit; margin-top: 175px;' />
            ): (
                <>
                    <CardBody>
                        <>
                            <Row>
                                <Column css={'flex: 0 0 34px; margin-left: -10px; padding-top: 2px;'}>
                                    <FormCheckbox
                                        name={'hasAgreed'}
                                        checked={hasAgreed}
                                        onChange={() => setHasAgreed(v => !v)}
                                    />
                                </Column>
                                <Column css={''}>
                                    <Paragraph>
                                        I consent to Manzil obtaining my credit score and credit report from credit reporting agencies. As well, I consent to Manzil verifying my income and down payment directly from my banking institution. I acknowledge this consent is obtained to allow Manzil to obtain and approve my mortgage application. I authorize the applicable credit reporting agencies to provide this data to Manzil.
                                    </Paragraph>
                                    {!isLargeScreen && (
                                        <PrivacyPolicy>
                                            <span onClick={openURL('https://manzil.ca/privacy-policy/')}>
                                                Privacy Policy
                                            </span>
                                        </PrivacyPolicy>
                                    )}
                                </Column>
                            </Row>
                        </>
                    </CardBody>
                    <CardFooter>
                        <Button
                            title="I accept"
                            type="button"
                            disabled={!(hasAgreed)}
                            onClick={onSubmit}
                            css={'text-transform: none; padding-bottom: 3px;'}
                            arrowCss={'padding-left: 0px; margin-top: 5px;'}
                        />
                    </CardFooter>
                </>
            )}
        </>
    );
};
